const MULTIPLIER = new Map([
    ['k', 1_000],
    ['m', 1_000_000],
    ['b', 1_000_000_000],
]);
const CURRENCY_BY_MARKER = new Map([
    ['$', 'USD'],
    ['usd', 'USD'],
    ['€', 'EUR'],
    ['eur', 'EUR'],
    ['£', 'GBP'],
    ['gbp', 'GBP'],
    ['chf', 'CHF'],
    ['sek', 'SEK'],
]);
/** Cells that say "there is no number here" rather than failing to parse. */
const BLANK = new Set(['', '-', '–', '—', 'n/a', 'na', 'tbd', 'unknown', '?']);
// No trailing word boundary: the sheet writes "EUR2.5-10M" with no space.
const CURRENCY = /[$€£]|\b(?:usd|eur|gbp|chf|sek)/i;
const AMOUNT = /(\d+(?:\.\d+)?)\s*([kmb])?\s*(\+)?/i;
const RANGE = new RegExp(String.raw `(\d+(?:\.\d+)?)\s*([kmb])?\s*\+?\s*(?:[-–—]|\bto\b)\s*` +
    String.raw `(?:[$€£]|\b(?:usd|eur|gbp|chf|sek))?\s*(\d+(?:\.\d+)?)\s*([kmb])?`, 'i');
function scale(amount, unit) {
    return Number(amount) * (unit === undefined ? 1 : (MULTIPLIER.get(unit.toLowerCase()) ?? 1));
}
/**
 * "$1M–$50M+", "€500K–€3M", "$10M+", "Unknown". Cells that carry more than one
 * range ("$2M–$8M (seed), $5M–$15M (A)") give up their first one; the caller
 * keeps the raw text so nothing is lost.
 *
 * Null means the cell states no usable number — the caller decides whether that
 * is worth a note.
 */
export function parseCheque(raw) {
    const text = (raw ?? '').trim();
    if (BLANK.has(text.toLowerCase()))
        return null;
    const currencyMatch = CURRENCY.exec(text);
    if (currencyMatch === null)
        return null;
    const currency = CURRENCY_BY_MARKER.get(currencyMatch[0].toLowerCase());
    if (currency === undefined)
        return null;
    const range = RANGE.exec(text);
    if (range !== null) {
        const [, minAmount, minUnit, maxAmount, maxUnit] = range;
        if (minAmount === undefined || maxAmount === undefined)
            return null;
        // "$25-100m": only the far end wears the unit, and it governs both.
        const min = scale(minAmount, minUnit ?? maxUnit);
        const max = scale(maxAmount, maxUnit ?? minUnit);
        return { min, max, currency };
    }
    const single = AMOUNT.exec(text);
    if (single === null)
        return null;
    const [, amount, unit, plus] = single;
    if (amount === undefined)
        return null;
    const value = scale(amount, unit);
    return { min: value, max: plus === undefined ? value : null, currency };
}
//# sourceMappingURL=cheque.js.map